import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Menu } from "../../../../components/Dropdown";
import Button from "../../../../components/elements/button";
import Icon from "../../../../components/icons";
import { Controller, useForm } from "react-hook-form";
import Datepicker from "../../../../components/elements/form/datepicker";
import Input from "../../../../components/elements/form/input";
import SelectBox from "../../../../components/elements/form/selectBox";
import GaapDepreciation from "./gaapDreprication";
import TaxDeprecation from "./taxDreprecation";
import AssetRevaluation from "./assetRevaluation";
import AssetDisposal from "./assetDisposal";
import { useDepreciationApi } from "../../../../store/api/hooks/depreciationApiHook";
import toast from "react-hot-toast";
import { watch } from "fs";
import { useLocation, useParams } from "react-router-dom";
import { useAssetsApi } from "../../../../store/api/hooks/assetsApiHook";
import moment from "moment";
import { DATE_FORMAT } from "../../../../_common/constant";
import Label from "../../../../components/elements/form/fromLabel";
import { getPermissionInfo, getSelectedOption } from "../../../../_common/functions";
import { useAppLoader } from "../../../../_common/pageLoader/appLoaderHook";
import Drawer from "../../../../components/Drawer";
import CreateRevaluate from "./createRevaluate";
import CreateDisposal from "./createDisposal";
import Currency from "../../../../components/currency";
import { useUserSelector } from "../../../../store/selectors/userSelector";

interface AccountingProps {
  purchaseCost: number;
  onAssetUpdate?: () => void;
}

const Accounting: React.FC<AccountingProps> = ({ purchaseCost, onAssetUpdate }) => {
  const {
    control,
    reset,
    handleSubmit,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      isMCARS: false,
    },
  });
  const [usefulLife, setUseFulLife] = useState<any>(null);
  const [consvensionlist, setConvensionList] = useState<any>(null);
  const { showLoader, hideLoader } = useAppLoader();
  const [consvensionmacrslist, setConvensionMarcList] = useState<any>(null);
  const [depreciationMethodList, setDepreciationMethodList] =
    useState<any>(null);
  const [taxList, setTaxList] = useState<any>(null);
  const [rowDetails, setRowdetails] = useState<any>(null);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const [isFormDataPopulated, setIsFormDataPopulated] = useState<boolean>(false);
  const isMCARSwatch = watch("isMCARS");
  const depreciationAPI = useDepreciationApi();
  const assetsAPI = useAssetsApi();
  const params: any = useParams();
  const gaapTableRef: any = useRef();
  const taxTableRef: any = useRef();
  const assestTableRef: any = useRef();
  const disposalTableRef: any = useRef();

  const [editData, setEditData] = useState<any>(null);

  const addNewAssetRevolutionRef: any = React.createRef<HTMLButtonElement>();
  const createAssetRevolutionRef: any = useRef();

  const addNewAssetDisposalRef: any = React.createRef<HTMLButtonElement>();
  const createAssetDisposalRef: any = useRef();
  const [revaluationData, setRevaluationData] = useState<any>(null);
  const [disposalData, setDisposalData] = useState<any>(null);
  const [rowData, setRowData] = useState<any>(null);
  const location = useLocation();
  const loggedinuser: any = useUserSelector();

  const GetUsefulLifeList = () => {
    const payload = {};
    depreciationAPI.GetUsefulLifeList(
      payload,
      (resp: any) => {
        console.log(resp);
        let usefullist: any = [];
        resp.usefulLifeList = resp && resp?.usefulLifeList && Array.isArray(resp.usefulLifeList) ? resp.usefulLifeList : [];

        resp.usefulLifeList.map((useful: any) => {
          usefullist.push({
            label: useful.usefulLifeValue,
            value: useful.usefulLifeID,
            data: useful,
          });
        });
        setUseFulLife(usefullist);
      },
      (error: any) => {
        console.log("error =>", error);
        toast.error(error);
      }
    );
  };

  const GetDepreciationConventionTypeList = (type: any) => {
    const payload: any = {};
    if (type == "isGaap") {
      payload.isGaap = true;
    } else {
      payload.isMACRS = true;
    }

    depreciationAPI.GetDepreciationConventionTypeList(
      payload,
      (resp: any) => {
        console.log(resp);
        let consvensionlist: any = [];
        resp.depreciationConventionTypeList = resp && resp?.depreciationConventionTypeList && Array.isArray(resp.depreciationConventionTypeList) ? resp.depreciationConventionTypeList : [];
        resp.depreciationConventionTypeList.map((useful: any) => {
          consvensionlist.push({
            label: useful.conventionTypeName,
            value: useful.conventionTypeID,
            data: useful,
          });
        });
        if (type == "isGaap") {
          setConvensionList(consvensionlist);
        } else {
          setConvensionMarcList(consvensionlist);
        }
      },
      (error: any) => {
        console.log("error =>", error);
        toast.error(error);
      }
    );
  };

  const GetConventionPercentageList = () => {
    const payload = {};
    depreciationAPI.GetConventionPercentageList(
      payload,
      (resp: any) => {
        console.log(resp);
        let taxlist: any = [];

        resp.conventionPercentageList = resp && resp?.conventionPercentageList && Array.isArray(resp.conventionPercentageList) ? resp.conventionPercentageList : [];
        resp.conventionPercentageList.map((useful: any) => {
          taxlist.push({
            label: useful.conventionPercentage,
            value: useful.conventionPercentageID,
            data: useful,
          });
        });
        setTaxList(taxlist);
      },
      (error: any) => {
        console.log("error =>", error);
        toast.error(error);
      }
    );
  };

  const GetDepreciationMethods = () => {
    const payload = {};
    depreciationAPI.GetDepreciationMethods(
      payload,
      (resp: any) => {
        console.log(resp);
        let taxlist: any = [];
        resp.depreciationMethodList = resp && resp?.depreciationMethodList && Array.isArray(resp.depreciationMethodList) ? resp.depreciationMethodList : [];
        resp.depreciationMethodList.map((useful: any) => {
          taxlist.push({
            label: useful.depreciationMethodName,
            value: useful.depreciationMethodID,
            data: useful,
          });
        });
        setDepreciationMethodList(taxlist);
        setValue("DepreciationMethodID", getSelectedOption(1, taxlist));
      },
      (error: any) => {
        console.log("error =>", error);
        toast.error(error);
      }
    );
  };

  const ValidateMCARSTransaction = () => {
    const payload = {
      MCARSConventionTypeID: getValues("mcarsConventionTypeID")?.value,
      ConventionPercentageID: getValues("conventionPercentageID")?.value,
      MCARSUsefulLifeID: getValues("MCARSUsefulLifeID")?.value,
      PurchaseDate: rowDetails?.purchaseDate,
    };
    depreciationAPI.ValidateMCARSTransaction(
      payload,
      (resp: any) => {
        if (resp.successful === false) {
          setDisableSubmit(true);
          toast.error(resp.message);
        } else {
          setDisableSubmit(false);
        }
      },
      (error: any) => {
        console.log("error =>", error);
        // toast.error(error);
        setDisableSubmit(false);
      }
    );
  };

  const getAssetsList = (assetID: any) => {
    const payload = {
      assetID: assetID,
    };
    showLoader();
    assetsAPI.getAssetsList(
      payload,
      (data: any) => {
        setRowdetails(data.assetList[0]);

        setValue(
          "gaapConventionTypeID",
          getSelectedOption(
            data.assetList[0].gaapConventionTypeID,
            consvensionlist
          )
        );
        setValue("isMCARS", data.assetList[0].isMCARS);
        setValue("UsefulLife", data.assetList[0].usefulLife);
        setValue(
          "MCARSUsefulLifeID",
          getSelectedOption(data.assetList[0].mcarsUsefulLifeID, usefulLife)
        );
        setValue(
          "mcarsConventionTypeID",
          getSelectedOption(
            data.assetList[0].mcarsConventionTypeID,
            consvensionmacrslist
          )
        );
        setValue(
          "conventionPercentageID",
          getSelectedOption(data.assetList[0].conventionPercentageID, taxList)
        );
        hideLoader();
      },
      (error: any) => { }
    );
  };

  const GetRevaluationList = (assetID: any = params.id) => {
    const payload = {
      assetID: assetID,
    };
    depreciationAPI.GetRevaluationList(
      payload,
      (data: any) => {
        setRevaluationData(data.revaluationList);
      },
      (error: any) => { }
    );
  };

  const GetDisposalList = (assetID: any = params.id) => {
    const payload = {
      assetID: assetID,
    };
    depreciationAPI.GetDisposalList(
      payload,
      (data: any) => {
        setDisposalData(data.disposalList);
      },
      (error: any) => { }
    );
  };

  const GetGAAPDepreciation = (assetID: any = params.id) => {
    console.log('Hooooooooooo==')
    const payload = {
      assetID: assetID,
    };
    depreciationAPI.GetGAAPDepreciation(
      payload,
      (data: any) => {
        setRowData(data.depreciationList);
      },
      (error: any) => { }
    );
  };

  useEffect(() => {
    if (
      params.id &&
      usefulLife &&
      consvensionlist &&
      consvensionmacrslist &&
      taxList
    ) {
      getAssetsList(params.id);
    }
  }, [params, usefulLife, consvensionlist, consvensionmacrslist, taxList]);
  useEffect(() => {
    if (params.id) {
      GetRevaluationList(params.id);
      GetDisposalList(params.id);
      GetGAAPDepreciation(params.id);
    }
  }, [params]);

  /* const onSubmit = (data: any) => {
    console.log("rowDetails ----> ", rowDetails);

    let payload: any = {
      assetID: rowDetails.assetID,

      usefulLife: data.UsefulLife,
      mcarsUsefulLifeID: data.isMCARS ? data.MCARSUsefulLifeID.value : 0,
      depreciationMethod: data.DepreciationMethodID.value,
      apportionTypeID: 1,
      isGAAP: true,
      gaapConventionTypeID: data?.gaapConventionTypeID?.value,
      isMCARS: data.isMCARS,
      mcarsConventionTypeID: data.isMCARS
        ? data.mcarsConventionTypeID.value
        : 0,
      conventionPercentageID: data.isMCARS
        ? data.conventionPercentageID.value
        : 0,
    };

    showLoader();
    depreciationAPI.SaveAssetDepreciation(
      payload,
      (resp: any) => {
        toast.success(resp?.message);

        gaapTableRef?.current?.reload();
        taxTableRef?.current?.reload();
        //formReset();
        hideLoader();
      },
      (error: any) => {
        console.log("error =>", error);
        hideLoader();
        toast.error(error);
      }
    );
    //console.log("Submit payload", payload);
  }; */

  const onSubmit = async (data: any) => {
    if (data.isMCARS) {
      // Step 1: Prepare payload for validation
      const validationPayload = {
        MCARSConventionTypeID: data.mcarsConventionTypeID?.value,
        ConventionPercentageID: data.conventionPercentageID?.value,
        MCARSUsefulLifeID: data.MCARSUsefulLifeID?.value,
        PurchaseDate: rowDetails?.purchaseDate,
      };

      // Step 2: Call validation API and wait for result
      const isValid = await new Promise<boolean>((resolve) => {
        depreciationAPI.ValidateMCARSTransaction(
          validationPayload,
          (resp: any) => {
            if (resp.successful === false) {
              toast.error(resp.message);
              resolve(false);
            } else {
              resolve(true);
            }
          },
          (error: any) => {
            console.log("Validation error:", error);
            toast.error("Validation failed.");
            resolve(false);
          }
        );
      });

      // Step 3: If not valid, stop here
      if (!isValid) {
        return;
      }
    }

    // ✅ MACRS is either disabled or valid — continue saving
    let payload: any = {
      assetID: rowDetails.assetID,
      usefulLife: data.UsefulLife,
      mcarsUsefulLifeID: data.isMCARS ? data.MCARSUsefulLifeID.value : 0,
      depreciationMethod: data.DepreciationMethodID.value,
      apportionTypeID: 2, // Assuming 2 is the monthly , 1 is yearly value for apportionTypeID
      isGAAP: true,
      gaapConventionTypeID: data?.gaapConventionTypeID?.value,
      isMCARS: data.isMCARS,
      mcarsConventionTypeID: data.isMCARS ? data.mcarsConventionTypeID.value : 0,
      conventionPercentageID: data.isMCARS ? data.conventionPercentageID.value : 0,
    };

    showLoader();
    depreciationAPI.SaveAssetDepreciation(
      payload,
      (resp: any) => {
        toast.success(resp?.message);
        gaapTableRef?.current?.reload();
        taxTableRef?.current?.reload();
        hideLoader();
      },
      (error: any) => {
        console.log("error =>", error);
        hideLoader();
        toast.error(error);
      }
    );
  };

  const formReset = () => {
    const currentMCARSValue = getValues("isMCARS"); // Preserve current MACRS checkbox state
    
    const resetData: any = {
      UsefulLife: null,
      gaapConventionTypeID: null,
      isMCARS: currentMCARSValue, // Preserve the current MACRS checkbox state
      // If MACRS is enabled, preserve the current values, otherwise set to null
      MCARSUsefulLifeID: currentMCARSValue ? getValues("MCARSUsefulLifeID") : null,
      mcarsConventionTypeID: currentMCARSValue ? getValues("mcarsConventionTypeID") : null,
      conventionPercentageID: currentMCARSValue ? getValues("conventionPercentageID") : null,
    };

    // If GAPP is posted to Sage, don't clear Useful Life and Convention
    if (rowDetails?.isGAPPPostedToSage) {
      delete resetData.UsefulLife;
      delete resetData.gaapConventionTypeID;
    }

    // If MACRS is enabled and GAPP is posted to Sage, don't clear MACRS related fields
    if (currentMCARSValue && rowDetails?.isGAPPPostedToSage) {
      delete resetData.conventionPercentageID;
      delete resetData.MCARSUsefulLifeID;
      delete resetData.mcarsConventionTypeID;
    }

    reset(resetData);
  };

  useEffect(() => {
    GetUsefulLifeList();
    GetDepreciationConventionTypeList("isGaap");
    GetDepreciationConventionTypeList("isMACRS");

    GetConventionPercentageList();
    GetDepreciationMethods();
  }, []);

  // Calculate permission for Manage Asset Accounting
  const hasAssetAccountingPermission = getPermissionInfo(location.pathname, "Manage Asset Accounting", loggedinuser);

  // Check if all form data is populated
  useEffect(() => {
    const isDataReady = 
      rowDetails && 
      usefulLife && 
      consvensionlist && 
      consvensionmacrslist && 
      taxList && 
      depreciationMethodList;
    
    setIsFormDataPopulated(!!isDataReady);
  }, [rowDetails, usefulLife, consvensionlist, consvensionmacrslist, taxList, depreciationMethodList]);


  return (
    <div>
      {rowDetails && (
        <div>
          <div className="flex items-center justify-between h-[70px]">
            <h4 className="font-semibold text-[0.938rem] py-4">
              Depreciation Schedule
            </h4>
            <Drawer isAfterOpenRender={true}
              _ref={addNewAssetRevolutionRef}
              onClose={() => {
                setEditData(null);
                createAssetRevolutionRef?.current?.reset();
              }}
              outsideClose={false}
            >
              <Drawer.Button>
                {/* <Button>{editData ? 'Edit' : 'Add New'} Revolution</Button> */}
              </Drawer.Button>
              <Drawer.Content
                title={
                  editData ? "Edit Asset Revaluation" : "Create Asset Revaluation"
                }
                className="!w-[39.563rem]"
              >
                <CreateRevaluate
                  _ref={createAssetRevolutionRef}
                  editData={editData}
                  purchaseDate={rowDetails?.purchaseDate}
                  usefulLife={rowDetails?.usefulLife}
                  onCreate={() => {
                    setEditData(null);
                    addNewAssetRevolutionRef?.current?.close();
                    GetRevaluationList(params.id); // Refresh revaluation data
                    onAssetUpdate?.();
                  }}
                  onCancel={() => {
                    setEditData(null);
                    addNewAssetRevolutionRef?.current?.close();
                    assestTableRef?.current?.reload();
                    gaapTableRef?.current?.reload();
                  }}
                />
              </Drawer.Content>
            </Drawer>

            <Drawer isAfterOpenRender={true}
              _ref={addNewAssetDisposalRef}
              onClose={() => {
                setEditData(null);
                createAssetDisposalRef?.current?.reset();
              }}
              outsideClose={false}
            >
              <Drawer.Button>
                {/* <Button>{editData ? 'Edit' : 'Add New'} Revolution</Button> */}
              </Drawer.Button>
              <Drawer.Content
                title={
                  editData ? "Edit Asset Disposal" : "Create Asset Disposal"
                }
                className="!w-[39.563rem]"
              >
                <CreateDisposal
                  _ref={createAssetDisposalRef}
                  editData={editData}
                  purchaseDate={rowDetails?.purchaseDate}
                  usefulLife={rowDetails?.usefulLife}
                  onCreate={() => {
                    setEditData(null);
                    addNewAssetDisposalRef?.current?.close();
                    // Reload all accounting data
                    getAssetsList(params.id); // Refresh main asset data
                    GetGAAPDepreciation(params.id); // Refresh GAAP depreciation data
                    GetDisposalList(params.id); // Refresh disposal data
                    gaapTableRef?.current?.reload(); // Reload GAAP table
                    taxTableRef?.current?.reload(); // Reload tax table
                    disposalTableRef?.current?.reload(); // Reload disposal table
                    onAssetUpdate?.(); // Notify parent component
                  }}
                  onCancel={() => {
                    setEditData(null);
                    addNewAssetDisposalRef?.current?.close();
                    disposalTableRef?.current?.reload();
                    GetDisposalList(params.id); // Refresh disposal data for menu text
                    GetGAAPDepreciation(params.id); // Refresh GAAP depreciation data
                    gaapTableRef?.current?.reload();
                  }}
                />
              </Drawer.Content>
            </Drawer>
            <Dropdown>
              <Dropdown.Button>
                <Button theme="light" className="h-[2.25rem]">
                  <Icon name="threedote" size={1.25} className="" />
                </Button>
              </Dropdown.Button>
              <Dropdown.Content
                title="Create New Facility"
                className="!w-[39.563rem]"
              >
                {/* {(!revaluationData ||
                  !revaluationData.some(
                    (item: any) =>
                      new Date(item.effectiveDate).getFullYear() === new Date().getFullYear()
                  )) && ( */}
                    {!rowDetails?.isDisposed &&<Menu disabled={!getPermissionInfo(location.pathname, "Manage Asset Accounting", loggedinuser)}
                      onClick={() => {
                        addNewAssetRevolutionRef?.current?.open();
                      }}
                    >
                      Revalue
                    </Menu>}
                 {/*  )} */}
                <Menu disabled={!getPermissionInfo(location.pathname, "Manage Asset Accounting", loggedinuser)}
                  onClick={() => {
                    // If disposal data exists, set it as edit data, otherwise set to null for new disposal
                    if (disposalData && disposalData.length > 0) {
                      setEditData(disposalData[0]); // Set the first disposal record for editing
                    } else {
                      setEditData(null); // Create new disposal
                    }
                    addNewAssetDisposalRef?.current?.open();
                  }}
                >
                  {disposalData && disposalData.length > 0 ? 'Edit Disposal' : 'Disposal'}
                </Menu>
                {/* <Menu onClick={onBulkExportCsv}>Export excel / csv </Menu>
                                            <Menu onClick={onBulkExportPdf}>Export pdf</Menu>
                                            <Menu onClick={onBulkPrintQR}>Print QR Code</Menu> */}
              </Dropdown.Content>
            </Dropdown>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid grid-cols-2 gap-8">
              <div>
                <Label text="Purchase Date" />
                {/* <p>{moment(rowDetails?.purchaseDate).format(DATE_FORMAT)}</p> */}
                <p>{rowDetails?.purchaseDate? moment(rowDetails.purchaseDate, 'YYYY-MM-DD HH:mm:ss').format(DATE_FORMAT): null}</p>
              </div>
              <div>
                <Label text="Cost Basis" />
                {/* <p>{rowDetails?.purchaseCost}</p> */}
                {/* <p>{purchaseCost}</p> */}
                <p><Currency currency="USD" value={revaluationData && revaluationData.length > 0 ? revaluationData[0].revaluedAmount : purchaseCost} /></p>
              </div>
            </div>

            {rowDetails.assetSubGroupName !== 'Land' && (
              <div>
                <div className="grid grid-cols-2 gap-8">
                  <div>
                    <div>
                      <h4 className="font-semibold text-[0.938rem] py-4">
                        Book Drepreciation
                      </h4>
                    </div>
                    <Controller
                      name="DepreciationMethodID"
                      control={control}
                      rules={{ required: "Depreciation required" }}
                      render={({ field: { value, onChange } }) => (
                        <SelectBox
                          label="Depreciation Method"
                          value={value}
                          onChange={onChange}
                          disabled
                          placeholder="Depreciation Method"
                          error={errors?.DepreciationMethodID?.message as any}
                          options={depreciationMethodList}
                        />
                      )}
                    />

                    <Controller
                      name="UsefulLife"
                      control={control}
                      rules={{ required: "Useful Life required" }}
                      render={({ field: { value, onChange } }) => (
                        <Input
                          label="Useful Life (Years)"
                          type="number"
                          value={value}
                          onChange={onChange}
                          disabled={rowDetails?.isGAPPPostedToSage}
                          //     required
                          placeholder="0"
                          error={errors.UsefulLife?.message as any}
                        />
                      )}
                    />
                    <Controller
                      name="gaapConventionTypeID"
                      control={control}
                      rules={{ required: "Convention required" }}
                      render={({ field: { value, onChange } }) => (
                        <SelectBox
                          label="Convention"
                          value={value}
                          onChange={onChange}
                          placeholder="Convention Method"
                          error={errors?.gaapConventionTypeID?.message as any}
                          options={consvensionlist}
                          disabled={rowDetails?.isGAPPPostedToSage}
                        />
                      )}
                    />
                  </div>

                  <div>
                    <div className="flex items-center gap-2">
                      <Controller
                        name="isMCARS"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <input
                            type="checkbox"
                            checked={value}
                            onChange={(e) => {
                              setValue("mcarsConventionTypeID", null);
                              setValue("conventionPercentageID", null);
                              setValue("MCARSUsefulLifeID", null);
                              setDisableSubmit(false);
                              onChange(e.target.checked);
                            }}
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                          />
                        )}
                      />
                      <h4 className="font-semibold text-[0.938rem] py-4">
                        Enable MACRS
                      </h4>
                    </div>

                    <Controller
                      name="conventionPercentageID"
                      control={control}
                      rules={{
                        required: isMCARSwatch ? "Tax Schedule required" : false,
                      }}
                      render={({ field: { value, onChange } }) => (
                        <SelectBox
                          label="Tax Schedule"
                          value={value}
                          //disabled={isMCARSwatch ? false : true}
                          disabled={isMCARSwatch ? false : true}
                          onChange={(e) => {
                            onChange(e);
                            //ValidateMCARSTransaction();
                          }}
                          placeholder="Tax Schedule"
                          error={errors?.conventionPercentageID?.message as any}
                          options={taxList}
                          
                        />
                      )}
                    />

                    <Controller
                      name="MCARSUsefulLifeID"
                      control={control}
                      rules={{
                        required: isMCARSwatch ? "Useful Life required" : false,
                      }}
                      render={({ field: { value, onChange } }) => (
                        <SelectBox
                          label="Useful Life (Years)"
                          value={value}
                          onChange={(e) => {
                            onChange(e);
                            //ValidateMCARSTransaction();
                            }}
                            disabled={isMCARSwatch ? false : true}
                            placeholder="Useful Life (Years)"
                            error={errors?.MCARSUsefulLifeID?.message as any}
                            options={usefulLife}
                          />
                          )}
                        />
                        <Controller
                          name="mcarsConventionTypeID"
                          control={control}
                          rules={{ required: isMCARSwatch ? "Convention required" : false }}
                          render={({ field: { value, onChange } }) => (
                          <SelectBox
                            label="Convention"
                            value={value}
                            disabled={isMCARSwatch ? false : true}
                            onChange={(e) => {
                            onChange(e);
                            //ValidateMCARSTransaction();
                          }}
                          placeholder="Convention Method"
                          error={errors?.mcarsConventionTypeID?.message as any}
                          options={consvensionmacrslist}
                        />
                      )}
                    />
                  </div>
                </div>

                {!rowDetails?.isFullyDepreciated &&<div className="flex justify-end gap-2 flex-shrink-0 pt-2 border-t border-gray-200">
                  <Button type="submit" disabled={disableSubmit || !getPermissionInfo(location.pathname, "Manage Asset Accounting", loggedinuser)} working={false}>
                    Save
                  </Button>
                  <Button disabled={!getPermissionInfo(location.pathname, "Manage Asset Accounting", loggedinuser) || !isFormDataPopulated}
                    type="button"
                    theme="secondary"
                    onClick={() => {
                      if (!getPermissionInfo(location.pathname, "Manage Asset Accounting", loggedinuser)) {
                        toast.error(`You don't have this permission`);
                        return;
                      } else if (!isFormDataPopulated) {
                        toast.error(`Please wait for all data to load before clearing the form`);
                        return;
                      } else {
                        formReset();
                      }
                    }}
                  >
                    Clear Form
                  </Button>
                </div>}
              </div>
            )}
          </form>

          {rowDetails.assetSubGroupName !== 'Land' && (
            <div>
              <GaapDepreciation 
                _ref={gaapTableRef} 
                isDisposed={rowDetails?.isDisposed} 
                hasPermission={hasAssetAccountingPermission} 
                onSagePostSuccess={() => {
                  getAssetsList(params.id);
                  onAssetUpdate?.();
                }} 
                onDisposalUpdate={(data) => {
                  setDisposalData(data);
                }}
              />
              <TaxDeprecation _ref={taxTableRef} hasPermission={hasAssetAccountingPermission} />
            </div>
          )}
          <AssetRevaluation _ref={assestTableRef} isDisposed={rowDetails?.isDisposed} hasPermission={hasAssetAccountingPermission} />
          <AssetDisposal _ref={disposalTableRef} hasPermission={hasAssetAccountingPermission} onDataChange={() => {
            // Comprehensive reload when disposal data changes
            getAssetsList(params.id); // Refresh main asset data
            GetGAAPDepreciation(params.id); // Refresh GAAP depreciation
            GetDisposalList(params.id); // Refresh disposal list
            gaapTableRef?.current?.reload(); // Reload GAAP table
            taxTableRef?.current?.reload(); // Reload tax table
            onAssetUpdate?.(); // Notify parent component
          }} />
        </div>
      )}
    </div>
  );
};

export default Accounting;
